class Buttons {
	constructor() {
		const buttons = document.querySelectorAll(".btn");

		if (!buttons) {
			return;
		}

		buttons.forEach(button => {
			const text = button.innerHTML;
			button.innerHTML = `<span>${text}</span>`;

		});
	}
}